import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

type PlanTier = 'MINI' | 'BASIC' | 'STANDARD' | 'PREMIUM' | 'ENTERPRISE';

interface PlanSelectorProps {
  selectedPlan: PlanTier | null;
  onPlanChange: (plan: PlanTier) => void;
  availablePlans: PlanTier[];
}

export function PlanSelector({ selectedPlan, onPlanChange, availablePlans }: PlanSelectorProps) {
  const { t } = useTranslation();

  const planLabels: Record<PlanTier, string> = {
    MINI: t('billing.plans.mini'),
    BASIC: t('billing.plans.basic'),
    STANDARD: t('billing.plans.standard'),
    PREMIUM: t('billing.plans.premium'),
    ENTERPRISE: t('billing.plans.enterprise'),
  };

  return (
    <div className="flex flex-wrap gap-2">
      {availablePlans.map((plan) => (
        <Button
          key={plan}
          variant={selectedPlan === plan ? 'default' : 'outline'}
          className={cn(
            'text-sm px-4 py-2',
            selectedPlan === plan
              ? 'bg-slate-800 text-white'
              : 'border-slate-300 text-slate-700'
          )}
          onClick={() => onPlanChange(plan)}
        >
          {planLabels[plan]}
        </Button>
      ))}
    </div>
  );
}

